import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { clientLandingRoute } from 'src/features/client-portal/utils/client-landing';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';

// TODO: Refactor shared/utils/routing/get-return-url.ts so that it can be used
// here instead, alongside auth guards.

function Redirect() {
  const auth = useAuth();
  const router = useRouter();
  const isSmallScreen = useIsSmallScreen();

  const { user, isAuthenticated } = auth;

  const handleClientRedirect = () => {
    router.push(
      clientLandingRoute({
        clientStage: user?.clientStage,
        isSmallScreen,
        personalPortfolioId: user?.personalPortfolioId,
      }),
    );
  };

  const handleNonClientRedirect = () => {
    router.push('/advisor');
  };

  useEffect(() => {
    if (!isAuthenticated || !user) {
      router.push('/login');
    } else if (user.role === 'CLIENT') {
      handleClientRedirect();
    } else if (user.role === 'NON_ADVISORY_USER') {
      router.push('/portfolio');
    } else {
      handleNonClientRedirect();
    }
  }, [auth, router]);

  return null;
}

export default Redirect;
